import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { PanelComponent, PanelHeaderComponent, TitleComponent } from '@rocksoft/cdk';

@Component({
  selector: 'ml-mdm-settings',
  templateUrl: './settings.component.html',
  imports: [PanelComponent, PanelHeaderComponent, TitleComponent, RouterLink, RouterLinkActive, RouterOutlet],
})
export class SettingsComponent {}
